<template>
    <div :class="[notis.length == 0 ? 'user_no_noti' : 'user_notis']">
        
        <div v-if="notis.length > 0" class="user_noti_lists">
            <div v-for="(noti,index) in notis" :key="'noti-' + index" :class=" noti.view == 0 ? 'user_noti new_noti' : 'user_noti'">
                <div class="user_noti_photo">
                    <svg v-if="noti.type == 'push-noti'" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0201 2.91003C8.71009 2.91003 6.02009 5.60003 6.02009 8.91003V11.8C6.02009 12.41 5.76009 13.34 5.45009 13.86L4.30009 15.77C3.59009 16.95 4.08009 18.26 5.38009 18.7C9.69009 20.14 14.3401 20.14 18.6501 18.7C19.8601 18.3 20.3901 16.87 19.7301 15.77L18.5801 13.86C18.2801 13.34 18.0201 12.41 18.0201 11.8V8.91003C18.0201 5.61003 15.3201 2.91003 12.0201 2.91003Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M13.8699 3.19994C13.5599 3.10994 13.2399 3.03994 12.9099 2.99994C11.9499 2.87994 11.0299 2.94994 10.1699 3.19994C10.4599 2.45994 11.1799 1.93994 12.0199 1.93994C12.8599 1.93994 13.5799 2.45994 13.8699 3.19994Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.90002 21.1801C9.36002 20.6401 9.02002 19.8801 9.02002 19.0601" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"/>
</svg>

                </div>
                <div class="user_noti_body">
                    <div class="user_noti_btitle">{{ noti.title }}</div>
                    <div class="user_noti_btext">{{ noti.text }}</div>
                </div>
            </div>
        </div>

        <div class="hcard-noItem" v-if="notis.length == 0">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.7499 2.45007C11.4499 1.86007 12.5799 1.86007 13.2599 2.45007L14.8399 3.80007C15.1399 4.05007 15.7099 4.26007 16.1099 4.26007H17.8099C18.8699 4.26007 19.7399 5.13007 19.7399 6.19007V7.89007C19.7399 8.29007 19.9499 8.85007 20.1999 9.15007L21.5499 10.7301C22.1399 11.4301 22.1399 12.5601 21.5499 13.2401L20.1999 14.8201C19.9499 15.1201 19.7399 15.6801 19.7399 16.0801V17.7801C19.7399 18.8401 18.8699 19.7101 17.8099 19.7101H16.1099C15.7099 19.7101 15.1499 19.9201 14.8499 20.1701L13.2699 21.5201C12.5699 22.1101 11.4399 22.1101 10.7599 21.5201L9.17988 20.1701C8.87988 19.9201 8.30988 19.7101 7.91988 19.7101H6.16988C5.10988 19.7101 4.23988 18.8401 4.23988 17.7801V16.0701C4.23988 15.6801 4.03988 15.1101 3.78988 14.8201L2.43988 13.2301C1.85988 12.5401 1.85988 11.4201 2.43988 10.7301L3.78988 9.14007C4.03988 8.84007 4.23988 8.28007 4.23988 7.89007V6.20007C4.23988 5.14007 5.10988 4.27007 6.16988 4.27007H7.89988C8.29988 4.27007 8.85988 4.06007 9.15988 3.81007L10.7499 2.45007Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M12 8.12988V12.9599" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M11.9946 16H12.0036" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
<b>Список уведомления пуст</b></div>

    </div>
  </template>
  
  <script>
  
  export default {
    name: 'User_noti',
    data(){
      return {
        notis: [],

      }
    },
    mounted(){
  this.getNotis()
    },
    props: ['isMobile'],
     methods:{
        getNotis(){
      axios.post('/api/user.get.notis', {'type': 'showNoti'})
                .then( res => {
                  if(res.data.status == 'success'){
                    this.notis = res.data.data.data
                  }
                  console.log(this.notis)
                }).catch( error => {
    
       })
    }
     }
  }
  </script>
  
  <style scoped>
  </style>